export default (location) => {
  const routeParams = {
    boardId: false,
    chartId: false,
  };

  const pathSplit = location.pathname.split('/');

  routeParams.baseUrl = `${location.origin + pathSplit[0]}/${pathSplit[1]}`;

  if (pathSplit.length >= 3 && pathSplit[2]) { routeParams.boardId = Number.parseInt(pathSplit[2], 10) || null; }

  if (pathSplit.length >= 4 && pathSplit[3]) { routeParams.chartId = Number.parseInt(pathSplit[3], 10) || null; }

  if (pathSplit.length >= 4 && pathSplit[2] === 'p' && pathSplit[3]) {
    routeParams.public_id = pathSplit[3]; // eslint-disable-line
  }

  if (pathSplit.length === 5 && pathSplit[1] === 'analytics' && pathSplit[2] === 'reset') {
    routeParams.reset = true; // eslint-disable-line
    routeParams.login = atob(pathSplit[3]); // eslint-disable-line
    routeParams.authcode = pathSplit[4]; // eslint-disable-line
  }

  return routeParams;
};
